import React, { Component } from "react";
import TextField from "@material-ui/core/TextField";
import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";
import Button from "@material-ui/core/Button";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@material-ui/icons/Save";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import SimCardDownloadIcon from "@mui/icons-material/SimCardDownload";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
// import Diversity2Icon from "@mui/icons-material/Diversity2";
import MaterialTable from "material-table";
import { Autocomplete } from "@mui/material";
import { withRouter } from "../../../withRouter";
import { ValidatorForm } from "react-material-ui-form-validator";
import { InputAdornment } from "@mui/material";
import { Buffer } from "buffer";
import Utils from "../../../provider/Utils";
import MenuWithBreadScrum from "../menu/MenuWithBreadScrum";
import CreateButton from "../buttons/CreateButton";
import CancelIconButton from "../buttons/CancelIconButton";
import FetchServerData from "../../../provider/FetchServerData";
import PtsAlert from "../ptsAlert/PtsAlert";
import store from "../../../redux/store";
import SaveButton from "../buttons/SaveButton";
import UiUtils from "../../../provider/UiUtils";
import PtsButton from "../buttons/PtsButton";
import BackButton from "../buttons/BackButton";
import Tooltip from "@material-ui/core/Tooltip";
// import Badge from "@material-ui/core/Badge";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import {
  CreateGroup_Url,
  DeleteContactsFromGroup_Url,
  DeleteGroup_Url,
  GetGroup_Url,
  ImportContacts_Url,
  UpdateGroup_Url,
  GetGroupList_Url,
  DeleteContactFromGroup_Url,
  FindByNumber_Url,
  CreateGroupContact_Url,
  UpdateContact_Url,
  ExportGroupContacts_Url,
  UserList_Url,
} from "../../../provider/ServiceUrl";
import SmsContactImportFile from "../../../assets/importTemplate/SmsContact_Import.csv";
import { BUSINESS_DOMAIN } from "../../../provider/Enums";
import RemoveContactButton from "../buttons/RemoveContactButton";
import Pagination from "../pagination/Pagination";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import PhoneInput from "react-phone-input-2";
import _ from "lodash";
import LinearProgressWithLabel from "../popUp/LinearProgressWithLabel ";
import Typography from "@mui/material/Typography";
import PaginationRowAction from "../../../redux/paginationRow/PaginationRowAction";
import AccountSettingDataAction from "../../../redux/accountSetting/AccountSettingDataAction";

class Group extends Component {
  fileUploadRef = React.createRef();
  header = store.getState().header.header;
  accountSettings = store.getState().accountSetting?.accountSetting;
  companyName =
    store.getState().appUserData.appUserData.appuser?.organization?.name;
  defaultCountry = store.getState().staticData.defaultCountry;
  countryListArray = store.getState().staticData.countryList;
  businessDomain =
    store.getState().appUserData.appUserData.appuser?.businessDomain;
  businessDomainId = store.getState().businessDomain?.businessDomainId;
  paginationState = store.getState().paginations.groupContactsState;
  profile = store.getState().appUserData.appUserData.appuser?.profile;

  paginationStateDetails = {};
  givbeeBreadCrumb = [
    { pageid: "/groups", uiname: "Groups" },
    { pageid: "", uiname: "Group Details" },
  ];
  eventBreadCrumb = [
    { pageid: "/eventGroups", uiname: "Groups" },
    { pageid: "", uiname: "Group Details" },
  ];

  dptextBreadCrumb = [
    { pageid: "/dptextGroups", uiname: "Groups" },
    { pageid: "", uiname: "Group Details" },
  ];
  constructor(props) {
    super(props);
    let action = props.action;
    let groupId = props.groupId;
    let pageId = props.pageId;
    let messageId = props.messageId;
    let contactId = props.contactId;
    if (!action && props.state) {
      action = props.state.action;
      groupId = props.state.groupId;
      messageId = props.state.messageId;
      contactId = props.state.contactId;
      pageId = props.state.pageId;
    }

    let breadCrumb = [];
    if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
      breadCrumb = this.eventBreadCrumb;
    } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
      breadCrumb = this.dptextBreadCrumb;
    } else {
      breadCrumb = this.givbeeBreadCrumb;
    }

    if (this.paginationState) {
      this.paginationStateDetails = Object.getOwnPropertyNames(
        this.paginationState
      );
    }

    this.state = {
      action: action,
      breadCrumb: breadCrumb,
      pageId: pageId,
      messageId: messageId,
      contactId: contactId,
      groupName: "",
      editGroupName: "",
      mobileNo: "",
      firstName: "",
      lastName: "",
      email: "",
      searchText: "",
      initialPage: 0,
      pageSize:
        this.paginationStateDetails?.length > 0
          ? this.paginationState?.pageSize
          : 20,
      progress: 0,
      smsContactList: [],
      smsGroupList: [],
      skippedNumbers: [],
      selectedFile: { name: "" },
      selectedSMSContactList: new Set(),
      getUpdatePermission: false,
      getDeletePermission: false,
      getReportPermission: false,
      isSelected: false,
      isPaging: false,
      open: false,
      isImportOpen: false,
      checkCSVFile: false,
      openViewGroup: false,
      isCtrlPressed: false,
      isShiftPressed: false,
      isDownloadReport: false,
      isContactConfirmBoxOpen: false,
      isProgress: false,
      render: false,
      isDragging: false,
      isImportDisableOpen: false,
      openSkippedNumbers: false,
      sortColumn: this.paginationStateDetails?.length > 0
        ? this.paginationState?.sortColumn : "lastMessageSenton",
      isAscSort: this.paginationStateDetails?.length > 0
        ? this.paginationState?.isAscSort : false,
      sortDirection: "desc",
      groupCreatedBy: null,
    };

    if (null !== groupId && groupId > 0) {
      this.getGroupDetails(groupId, this.state.pageNo, this.state.pageSize, this.state.sortColumn, this.state.isAscSort);
      this.debouncedSearch = _.debounce(this.getGroupDetails, 800);
    }
  }

  getGroupDetails(groupId, pageNo, pageSize, sortBy, isAscSort) {
    const postObject = {
      header: this.header,
      smsGroup: {
        id: groupId,
        event: {
          id: this.businessDomainId,
        },
      },
      page: {
        searchText:
          this.state.searchText !== undefined ? this.state.searchText : "",
        pageNo: pageNo ? pageNo : this.state.initialPage,
        pageSize: pageSize ? pageSize : this.state.pageSize,
        sortBy: sortBy,
        isAscSort: isAscSort,
      },
    };
    FetchServerData.callPostService(GetGroup_Url, postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          let smsGroup = output.data.smsGroup;
          let page = output.data.page;
          let contactList = output.data?.smsGroup?.contactList;
          let getPermission = Utils.getRolePermission(
            output.data?.privilegeList
          );
          let getSubDomainPermission =
            output.data.subDomainObjectPrivileges?.GroupReport;
          let getUpdatePermission = getPermission[3];
          let getDeletePermission = getPermission[4];
          let getReportPermission =
            getSubDomainPermission === null ? false : true;
          let isPaging = false;
          if (contactList.length > this.state.pageSize) {
            isPaging = true;
          }
          for (let i = 0; i < contactList?.length; i++) {
            const element = contactList[i];
            contactList[i].mobile = Utils.viewTollFreeNumberFormate(
              element.mobile
            );
            if (contactList[i].lastMessageSenton !== null) {
              if (contactList[i].contactStatus === "InvalidNumber") {
                contactList[i].lastMessageSenton =
                  "Failed with last send attempt.";
              } else {
                contactList[i].lastMessageSenton = Utils.getUtcToLocalDateTime(
                  element.lastMessageSenton
                );
              }
            } else {
              contactList[i].lastMessageSenton = "";
            }
          }
          let accountSetting = output.data?.accountSetting;
          store.dispatch(AccountSettingDataAction.setAccountSettingData({ accountSetting }));
          this.setState({
            render: true,
            // open: false,
            isImportOpen: false,
            checkCSVFile: false,
            selectedFile: { name: "" },
            action: "view",
            isPaging: isPaging,
            groupName: smsGroup.name,
            editGroupName: smsGroup.name,
            groupId: smsGroup.id,
            smsContactList: contactList,
            pageNo: page.pageNo,
            showPerPage: page.pageSize,
            totalPages: page.totalPages,
            totalRecords: page.total,
            getUpdatePermission: getUpdatePermission,
            getDeletePermission: getDeletePermission,
            getReportPermission: getReportPermission,
          });
        } else {
        }
      })
      .catch((error) => { });
  }

  onPaginationChange(returnProp) {
    let counter = returnProp.counter;
    let pageNo = this.state.pageNo + counter;
    let pageSize = returnProp.showPerPage;
    const groupContactsState = {
      pageSize: pageSize,
      sortColumn: this.state.sortColumn,
      isAscSort: this.state.isAscSort,
    };
    store.dispatch(
      PaginationRowAction.setGroupContactsPaginationState({ groupContactsState })
    );
    let buttonIndex = returnProp.buttonIndex;
    let currentPageIndex =
      typeof counter !== "undefined" ? pageNo : buttonIndex;
    let resetPageNo = returnProp.resetPageNo;
    if (resetPageNo === true) {
      currentPageIndex = 0;
    }
    let dataRows = this.state.smsContactList;
    for (let i = 0; i < dataRows.length; i++) {
      dataRows[i].checked = false;
      this.setState({
        allCheckBoxSelected: false,
        isSelected: false,
      });
    }
    this.setState({
      pageNo: currentPageIndex,
      pageSize: pageSize,
    });
    this.getGroupDetails(this.state.groupId, currentPageIndex, pageSize, this.state.sortColumn, this.state.isAscSort);
  }

  onSearchChange(e) {
    this.setState({ searchText: e.target.value });
    this.debouncedSearch(
      this.state.groupId,
      this.state.pageNo,
      this.state.pageSize
    );
  }

  componentDidMount() {
    window.addEventListener("keydown", this.handleKeyDown);
    window.addEventListener("keyup", this.handleKeyUp);
  }

  componentWillUnmount() {
    window.removeEventListener("keydown", this.handleKeyDown);
    window.removeEventListener("keyup", this.handleKeyUp);
  }

  handleKeyDown = (event) => {
    if (event.key === "Control") {
      this.setState({ isCtrlPressed: true });
    } else if (event.key === "Shift") {
      this.setState({ isShiftPressed: true });
    }
  };

  handleKeyUp = (event) => {
    if (event.key === "Control") {
      this.setState({ isCtrlPressed: false });
    } else if (event.key === "Shift") {
      this.setState({ isShiftPressed: false });
    }
  };

  handleGroupNameChange(e) {
    this.setState({
      groupName: e.target.value,
    });
  }
  handleEditGroupNameChange(e) {
    this.setState({
      editGroupName: e.target.value,
    });
  }

  handleImportDropdownClose = () => {
    this.setState({
      isImportOpen: false,
      anchorEl: null,
      checkCSVFile: false,
      selectedFile: { name: "" },
    });
  };
  handleSkippedNumbersClose = () => {
    this.setState({
      openSkippedNumbers: false,
    });
  };

  handleImportDropdownOpen = (e) => {
    this.setState({ isImportOpen: true, anchorEl: e.currentTarget });
  };

  handleImportDisableOpen() {
    this.setState({
      isImportDisableOpen: true,
    });
  }

  handleImportDisableClose() {
    this.setState({
      isImportDisableOpen: false,
    });
  }

  checkCSVFilekHandler(e) {
    this.setState({ checkCSVFile: e.target.checked });
  }
  createGroupToBackend() {
    const postObject = {
      header: this.header,
      smsGroup: {
        name: this.state.groupName,
        event: {
          id: this.businessDomainId,
        },
      },
    };
    FetchServerData.callPostService(CreateGroup_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          let smsGroup = output.data.smsGroup;
          this.getGroupDetails(smsGroup.id);
          this.setState({
            action: "view",
            open: false,
          });
        } else {
        }
      }
    );
  }

  createCancel() {
    if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
      this.props.navigate("/eventGroups");
    } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
      this.props.navigate("/dptextGroups");
    } else {
      this.props.navigate("/groups");
    }
  }

  viewCancel() {
    if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
      if (this.state.pageId === "AllActiveContact") {
        this.props.navigate("/eventContacts");
      } else if (this.state.pageId === "SendQwikText") {
        this.props.navigate("/eventQwiktext");
      } else if (this.state.pageId === "PreviewAndSend") {
        this.props.navigate("/eventPreviewAndSend", {
          state: {
            action: "view",
            messageId: this.state.messageId,
          },
        });
      } else {
        this.props.navigate("/eventGroups");
      }
    } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
      if (this.state.pageId === "AllActiveContact") {
        this.props.navigate("/dptextContacts");
      } else if (this.state.pageId === "SendQwikText") {
        this.props.navigate("/dptextQwiktext");
      } else if (this.state.pageId === "PreviewAndSend") {
        this.props.navigate("/dptextPreviewAndSend", {
          state: {
            action: "view",
            messageId: this.state.messageId,
          },
        });
      } else {
        this.props.navigate("/dptextGroups");
      }
    } else {
      if (this.state.pageId === "AllActiveContact") {
        this.props.navigate("/contacts");
      } else if (this.state.pageId === "SendQwikText") {
        this.props.navigate("/qwiktext");
      } else if (this.state.pageId === "PreviewAndSend") {
        this.props.navigate("/previewAndSend", {
          state: {
            action: "view",
            messageId: this.state.messageId,
          },
        });
      } else {
        this.props.navigate("/groups");
      }
    }
  }

  editCancel() {
    this.setState({
      action: "view",
      groupId: this.state.groupId,
    });
  }

  editGroupDetails(e) {
    this.setState({
      action: "edit",
      groupId: this.state.groupId,
    });
  }

  updateGroupToBackend() {
    const postObject = {
      header: this.header,
      smsGroup: {
        name: this.state.editGroupName,
        id: this.state.groupId,
        createdBy: this.state.groupCreatedBy?.id,
        event: {
          id: this.businessDomainId,
        },
      },
    };
    FetchServerData.callPostService(UpdateGroup_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          let smsGroup = output.data.smsGroup;
          this.getGroupDetails(smsGroup.id);
          this.setState({
            action: "view",
            openGroup: false,
            open: false,
          });
        } else {
        }
      }
    );
  }

  deleteGroupToBackend() {
    const postObject = {
      header: this.header,
      smsGroup: {
        id: this.state.groupId,
      },
    };

    FetchServerData.callPostService(DeleteGroup_Url, postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
            this.props.navigate("/eventGroups");
          } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
            this.props.navigate("/dptextGroups");
          } else {
            this.props.navigate("/groups");
          }
        } else {
        }
      })
      .catch((error) => { });
  }

  addNewContact() {
    if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
      this.props.navigate("/eventContact", {
        state: {
          action: "create",
          groupId: this.state.groupId,
          smsContactList: this.state.smsContactList,
        },
      });
    } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
      this.props.navigate("/dptextContact", {
        state: {
          action: "create",
          groupId: this.state.groupId,
          smsContactList: this.state.smsContactList,
        },
      });
    } else {
      this.props.navigate("/contact", {
        state: {
          action: "create",
          groupId: this.state.groupId,
          groupName: this.state.groupName,
          smsContactList: this.state.smsContactList,
        },
      });
    }
  }

  toContactDetails(e, data) {
    if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
      this.props.navigate("/eventContact", {
        state: {
          action: "view",
          contactId: data.id,
          groupId: this.state.groupId,
          smsContactList: this.state.smsContactList,
        },
      });
    } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
      this.props.navigate("/dptextContact", {
        state: {
          action: "view",
          contactId: data.id,
          groupId: this.state.groupId,
          smsContactList: this.state.smsContactList,
        },
      });
    } else {
      this.props.navigate("/contact", {
        state: {
          action: "view",
          contactId: data.id,
          groupId: this.state.groupId,
          smsContactList: this.state.smsContactList,
        },
      });
    }
  }

  deleteMultipleContact() {
    let deleteSmsContactList = [];
    for (let i = 0; i < this.state.smsContactList.length; i++) {
      if (this.state.smsContactList[i].checked === true) {
        deleteSmsContactList.push({
          id: this.state.smsContactList[i].contactId,
        });
      }
    }
    const postObject = {
      header: this.header,
      smsGroup: {
        id: this.state.groupId,
      },
      smsContactList: deleteSmsContactList,
      eventId: this.businessDomainId,
    };
    FetchServerData.callPostService(
      DeleteContactsFromGroup_Url,
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let smsGroup = output.data.smsGroup;
        let contactList = smsGroup.contactList;
        PtsAlert.success(output.message);
        for (let i = 0; i < contactList.length; i++) {
          contactList[i].checked = false;
          this.setState({
            allCheckBoxSelected: false,
            isSelected: false,
          });
        }
        this.setState({
          isSelected: false,
          isContactConfirmBoxOpen: false,
          smsContactList: smsGroup.contactList,
        });
      }
    });
  }

  onFileChange = (file) => {
    // const file = event.target.files[0];

    if (file) {
      const fileName = file.name.toLowerCase();

      // Validate file extension
      if (!fileName.endsWith(".csv")) {
        PtsAlert.error("Please upload valid CSV file.");
        this.setState({ selectedFile: { name: "" } });
        return;
      }

      // Update state if valid file is selected
      this.setState({ selectedFile: file });
    }
  };

  // excelImportContactToGroup = (e) => {
  //   this.setState({ isProgress: true, progress: 0 });
  //   if (
  //     !this.state.selectedFile?.name ||
  //     this.state.selectedFile?.name === ""
  //   ) {
  //     PtsAlert.error("Please select file to upload");
  //     return;
  //   }
  //   let header = store.getState().header.header;
  //   const formData = new FormData();

  //   // Update the formData object
  //   formData.append(
  //     "file",
  //     this.state.selectedFile,
  //     this.state.selectedFile.name
  //   );
  //   formData.append("sessionid", header.sessionid);
  //   formData.append("tid", header.tid);
  //   formData.append("userid", header.userid);
  //   formData.append("appclient", header.appclient);
  //   formData.append("isAp", header.isAp);
  //   formData.append("groupId", this.state.groupId);
  //   formData.append("groupName", "");
  //   formData.append("iscreategGroup", false);
  //   formData.append("eventId", this.businessDomainId);
  //   FetchServerData.callPostFileUpload(ImportContacts_Url, formData, {
  //     onUploadProgress: (progressEvent) => {
  //       const percent = Math.round(
  //         (progressEvent.loaded * 100) / progressEvent.total
  //       );
  //       this.setState({
  //         progress: percent >= 95 ? 95 : percent,
  //       });
  //     },
  //   }).then((output) => {
  //     if (output.status === "SUCCESS") {
  //       // this.fileUploadRef.current?.value = "";
  //       const smsGroup = output.data?.smsGroup;
  //       const skippedNumbers = smsGroup?.skippedNumbers || [];

  //       this.setState({ progress: 100 }, () => {
  //         setTimeout(() => {
  //           this.setState({ isProgress: false, isImportOpen: false });
  //           if (skippedNumbers?.length > 0) {
  //             this.setState({
  //               openSkippedNumbers: true,
  //               skippedNumbers: skippedNumbers,
  //             });
  //           }
  //           this.getGroupDetails(this.state.groupId, this.state.pageNo, this.state.pageSize, this.state.sortColumn, this.state.isAscSort);
  //         }, 800);
  //       });
  //     } else {
  //       this.setState({ isProgress: false });
  //     }
  //   });
  // };

  excelImportContactToGroup = () => {
    this.setState({ isProgress: true, progress: 0 });

    if (!this.state.selectedFile?.name) {
      PtsAlert.error("Please select file to upload");
      this.setState({ isProgress: false });
      return;
    }

    const header = store.getState().header.header;
    const formData = new FormData();

    formData.append("file", this.state.selectedFile, this.state.selectedFile.name);
    formData.append("sessionid", header.sessionid);
    formData.append("tid", header.tid);
    formData.append("userid", header.userid);
    formData.append("appclient", header.appclient);
    formData.append("isAp", header.isAp);
    formData.append("groupId", this.state.groupId);
    formData.append("groupName", "");
    formData.append("iscreategGroup", false);
    formData.append("eventId", this.businessDomainId);

    FetchServerData.callPostFileUpload(ImportContacts_Url, formData, {
      timeout: 0,
      onUploadProgress: (progressEvent) => {
        if (!progressEvent.total) return;

        // Upload → 0–50%
        const uploadPercent = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );

        const mapped = Math.min(50, Math.round(uploadPercent / 2));
        this.setState({ progress: mapped });
      },
    })
      .then((output) => {
        this.stopPendingProgress();

        if (output.status === "SUCCESS") {
          this.setState({ progress: 100 }, () => {
            setTimeout(() => {
              this.setState({
                isProgress: false,
                isImportOpen: false,
              });

              const skippedNumbers =
                output?.data?.smsGroup?.skippedNumbers || [];

              if (skippedNumbers.length > 0) {
                this.setState({
                  openSkippedNumbers: true,
                  skippedNumbers,
                });
              }

              this.getGroupDetails(
                this.state.groupId,
                this.state.pageNo,
                this.state.pageSize,
                this.state.sortColumn,
                this.state.isAscSort
              );
            }, 500);
          });
        } else {
          this.setState({ isProgress: false });
        }
      })
      .catch(() => {
        this.stopPendingProgress();
        this.setState({ isProgress: false });
        PtsAlert.error("Import failed");
      });

    // Start fake progress while service is pending
    this.startPendingProgress();
  };

  startPendingProgress = () => {
    this.pendingProgressTimer = setInterval(() => {
      this.setState((prev) => {
        if (prev.progress >= 90) return null; // stop at 90%
        return { progress: prev.progress + 1 };
      });
    }, 800);
  };

  stopPendingProgress = () => {
    if (this.pendingProgressTimer) {
      clearInterval(this.pendingProgressTimer);
      this.pendingProgressTimer = null;
    }
  };

  excelDownloadGroupContacts() {
    if (this.state.smsContactList.length === 0) {
      PtsAlert.error("No contacts available");
      return;
    }
    const postObject = {
      header: this.header,
      smsGroup: {
        id: this.state.groupId,
        event: {
          id: this.businessDomainId,
        },
      },
    };

    FetchServerData.callPostService(ExportGroupContacts_Url, postObject).then(
      (output) => {
        let AllContactExcelData = output.data;
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          const byteArray = new Buffer(
            AllContactExcelData.data.replace(/^.+base64,/, ""),
            "base64"
          );
          const outputFilename = AllContactExcelData.filename;
          const url = URL.createObjectURL(new Blob([byteArray]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", outputFilename);
          document.body.appendChild(link);
          link.click();
        } else {
        }
      }
    );
  }

  getViewGroupList(contactId) {
    const postObject = {
      header: this.header,
      smsContact: {
        id: contactId,
        // event: {
        //   id: this.businessDomainId,
        // },
      },
      eventId: this.businessDomainId,
    };

    FetchServerData.callPostService(GetGroupList_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let smsContact = output.data.smsContact;
          let smsGroupList = output.data.groupList;
          for (let i = 0; i < smsGroupList.length; i++) {
            smsGroupList[i].createdOn = this.businessDomain === BUSINESS_DOMAIN.eventText ? Utils.getUtcToEventLocalTime(smsGroupList[i].createdOn) : Utils.getUtcToLocal(
              smsGroupList[i].createdOn
            );
          }
          this.setState({
            render: true,
            openViewGroup: true,
            contactId: smsContact.id,
            mobileNo: smsContact.mobile,
            firstName: smsContact.firstName,
            lastName: smsContact.lastName,
            email: smsContact.email,
            smsGroupList: smsGroupList,
          });
        } else {
        }
      }
    );
  }

  handleViewGroupOpen() {
    this.setState({ openViewGroup: true });
  }

  handleViewGroupClose() {
    this.setState({ openViewGroup: false });
  }

  handleContactsDialogBoxOpen() {
    if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
      this.props.navigate("/eventContactsFromOtherGroup", {
        state: {
          targetGroupName: this.state.groupName,
          targetGroupId: this.state.groupId,
        },
      });
    } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
      this.props.navigate("/dptextContactsFromOtherGroup", {
        state: {
          targetGroupName: this.state.groupName,
          targetGroupId: this.state.groupId,
        },
      });
    } else {
      this.props.navigate("/contactsFromOtherGroup", {
        state: {
          targetGroupName: this.state.groupName,
          targetGroupId: this.state.groupId,
        },
      });
    }
  }

  showActionButton(rowData) {
    return (
      <>
        <div style={{ display: "inline-flex", alignItems: "center" }}>
          <span className="me-2" style={{ cursor: "pointer" }}>
            <span
              key={rowData.id}
              className="edit"
              onClick={() => this.handleEditContactOpen(rowData)}
              style={{
                cursor: "pointer",
                fontSize: "small",
                display: "flex",
                textTransform: "capitalize",
              }}
            >
              <Tooltip title="Edit" classes={{ popper: "custom-tooltip" }}>
                <EditIcon
                  style={{
                    borderRadius: "25%",
                    color: "#6A7B8E",
                    fontSize: "small",
                    width: "30px",
                    minHeight: "30px",
                    padding: "3px",
                  }}
                />
              </Tooltip>
            </span>
          </span>
          <span className="me-2" style={{ cursor: "pointer" }}>
            <RemoveContactButton
              domainObject={rowData.mobile}
              onClick={this.deleteContactToGroup.bind(this, rowData)}
              pageId="contactGroup"
            />
          </span>
          <Tooltip
            title="Groups Belonging To"
            classes={{ popper: "custom-tooltip" }}
          >
            {/* <a
              href="#"
              style={{ cursor: "pointer", color: "#337ab7" }}
              onClick={this.getViewGroupList.bind(this, rowData.contactId)}
            >
     
              <i
                className="menu-icon tf-icons fas fa-users"
                style={{
                  color: "#6A7B8E",
                  fontSize: "19px",
                  padding: "3px",
                }}
              ></i>
            </a> */}
            <button
              type="button"
              onClick={() => this.getViewGroupList(rowData.contactId)}
              style={{
                cursor: "pointer",
                color: "#337ab7",
                background: "transparent",
                border: "none",
                padding: 0,
              }}
            >
              <i
                className="menu-icon tf-icons fas fa-users"
                style={{
                  color: "#6A7B8E",
                  fontSize: "19px",
                  padding: "3px",
                }}
              ></i>
            </button>
          </Tooltip>
          {Utils.equalsIgnoreCase(rowData.status, "Active") && (
            <i
              className="fa fa-circle ms-4"
              style={{ color: "green", fontSize: "small" }}
              aria-hidden="true"
            ></i>
          )}
          {Utils.equalsIgnoreCase(rowData.status, "InActive") && (
            <i
              className="fa fa-circle ms-4"
              style={{ color: "yellow", fontSize: "small" }}
              aria-hidden="true"
            ></i>
          )}
          {Utils.equalsIgnoreCase(rowData.status, "OptOut") && (
            <i
              className="fa fa-circle ms-4"
              style={{ color: "red", fontSize: "small" }}
              aria-hidden="true"
            ></i>
          )}
        </div>
      </>
    );
  }

  actionButton() {
    return (
      <>
        <div className="row">
          <span className="text-start pe-0">
            {!Utils.equalsIgnoreCase(this.profile?.name, "Sender") &&
              <>
                {
                  this.accountSettings?.enableImport ? (
                    <Button
                      id="ptsHollowButton"
                      type="button"
                      variant="contained"
                      className="btn-default "
                      onClick={this.handleImportDropdownOpen}
                      startIcon={<UploadFileIcon style={{ fontSize: "16px" }} />}
                    >
                      Import Contacts
                    </Button>
                  ) : (
                    <Button
                      id="ptsHollowButton"
                      type="button"
                      variant="contained"
                      className="btn-default "
                      onClick={this.handleImportDisableOpen.bind(this)}
                      startIcon={<UploadFileIcon style={{ fontSize: "16px" }} />}
                    >
                      Import Contacts
                    </Button>
                  )
                }
                &nbsp;&nbsp;&nbsp;
              </>
            }
            <Button
              id="ptsHollowButton"
              type="button"
              variant="contained"
              className="btn btn-default btn info"
              startIcon={<AddIcon />}
              onClick={this.handleContactsDialogBoxOpen.bind(this)}
            >
              Add from Other Groups
            </Button>
            &nbsp;&nbsp;&nbsp;
            {this.state.getReportPermission ? (
              <Button
                id="downloadExcelButton"
                type="button"
                variant="contained"
                className="btn success"
                startIcon={<SimCardDownloadIcon style={{ fontSize: "16px" }} />}
                onClick={(e) => this.excelDownloadGroupContacts()}
              >
                Download Group
              </Button>
            ) : (
              <Button
                id="downloadExcelButton"
                type="button"
                variant="contained"
                className="btn success"
                startIcon={<SimCardDownloadIcon style={{ fontSize: "16px" }} />}
                onClick={this.handleDownloadReportOpen.bind(this)}
              >
                Download Group
              </Button>
            )}
            &nbsp;&nbsp;&nbsp;
            {this.state.isSelected && (
              <Button
                id="ptsHollowButton"
                variant="contained"
                type="submit"
                className="btn btn-default "
                startIcon={
                  <i
                    className="fa-regular fa-trash-can"
                    aria-hidden="true"
                    style={{
                      borderRadius: "25%",
                      color: "#23527c",
                      fontSize: "16px",
                      width: "30px",
                      minHeight: "22px",
                      padding: "3px",
                      alignContent: "center",
                      textAlign: "center",
                      fontWeight: "600",
                    }}
                  ></i>
                }
                onClick={this.handleDeleteContactsOpen.bind(this)}
              >
                Delete from group
              </Button>
            )}
          </span>
        </div >
      </>
    );
  }
  toGroupDetails(e, data) {
    this.getGroupDetails(data.id);
    this.setState({
      openViewGroup: false,
    });
  }

  editContactDetails(e, data) {
    if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
      this.props.navigate("/eventContact", {
        state: {
          action: "edit",
          contactId: data.contactId,
          groupId: this.state.groupId,
        },
      });
    } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
      this.props.navigate("/dptextContact", {
        state: {
          action: "edit",
          contactId: data.contactId,
          groupId: this.state.groupId,
        },
      });
    } else {
      this.props.navigate("/contact", {
        state: {
          action: "edit",
          contactId: data.contactId,
          groupId: this.state.groupId,
        },
      });
    }
  }

  handleMaterialTablePageChange(page, pageSize) {
    this.setState({ initialPage: page, pageSize: pageSize });
  }

  deleteContactToGroup(data) {
    const postObject = {
      header: this.header,
      smsGroupContact: {
        smsGroup: {
          id: this.state.groupId,
        },
        smsContact: {
          id: data.contactId,
        },
        eventId: this.businessDomainId,
      },
      page: {
        searchText:
          this.state.searchText !== undefined ? this.state.searchText : "",
        pageNo: this.state.initialPage,
        pageSize: this.state.pageSize,
      },
    };

    FetchServerData.callPostService(DeleteContactFromGroup_Url, postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          let smsGroup = output.data.smsGroup;
          let page = output.data.page;
          let contactList = output.data?.smsGroup?.contactList;
          let getPermission = Utils.getRolePermission(
            output.data?.privilegeList
          );
          let getSubDomainPermission =
            output.data.subDomainObjectPrivileges?.GroupReport;
          let getUpdatePermission = getPermission[3];
          let getDeletePermission = getPermission[4];
          let getReportPermission =
            getSubDomainPermission === null ? false : true;
          let isPaging = false;
          if (contactList.length > this.state.pageSize) {
            isPaging = true;
          }
          for (let i = 0; i < contactList?.length; i++) {
            const element = contactList[i];
            contactList[i].mobile = Utils.viewTollFreeNumberFormate(
              element.mobile
            );
            contactList[i].lastMessageSenton = Utils.getUtcToLocalDateTime(
              element.lastMessageSenton
            );
          }
          this.setState((prev) => ({
            ...prev,
            render: true,
            open: false,
            isImportOpen: false,
            checkCSVFile: false,
            selectedFile: { name: "" },
            action: "view",
            isPaging: isPaging,
            groupName: smsGroup.name,
            groupId: smsGroup.id,
            smsContactList: contactList,
            pageNo: page?.pageNo,
            showPerPage: page?.pageSize,
            totalPages: page?.totalPages,
            totalRecords: page?.total,
            getUpdatePermission: getUpdatePermission,
            getDeletePermission: getDeletePermission,
            getReportPermission: getReportPermission,
          }));
        } else {
        }
      })
      .catch((error) => { });
  }

  onCheckBoxSelect(e, rowData, index) {
    const { isCtrlPressed, isShiftPressed } = this.state;
    let selectedItems = this.state.smsContactList;
    if (isCtrlPressed || isShiftPressed) {
      let firstItemIndex;
      for (let i = 0; i < selectedItems.length; i++) {
        const element = selectedItems[i];
        if (element.checked === true) {
          firstItemIndex = i;
          break;
        }
      }

      let lastItem = index;
      if (firstItemIndex > lastItem) {
        let tempt = lastItem;
        lastItem = firstItemIndex;
        firstItemIndex = tempt;
      }

      for (let i = firstItemIndex; i <= lastItem; i++) {
        selectedItems[i].checked = true;
      }
    } else {
      for (let i = 0; i < selectedItems.length; i++) {
        if (rowData.id === selectedItems[i].id) {
          if (e.target.checked) {
            selectedItems[i].checked = true;
          } else {
            selectedItems[i].checked = false;
            this.setState({
              allCheckBoxSelected: false,
            });
          }
        }
      }
    }
    const allChecked = selectedItems.every((item) => item.checked);

    const anyChecked = selectedItems.some((item) => item.checked);
    this.setState({
      smsContactList: [...selectedItems],
      allCheckBoxSelected: allChecked,
      isSelected: anyChecked,
    });
  }

  onAllCheckBoxSelect(e) {
    let isChecked = e.target.checked;
    let dataRows = this.state.smsContactList;
    for (let i = 0; i < dataRows.length; i++) {
      const row = dataRows[i];
      this.onCheckBoxSelect(e, row, i);
    }
    this.setState({
      allCheckBoxSelected: isChecked,
    });
  }

  groupTitle() {
    return (
      <>
        <span className="d-flex">
          {"Manage group"}:
          <span className="ms-1 me-2 d-flex" style={{ color: "#337ab7" }}>
            {this.state.groupName}{" "}
          </span>
          {this.state.getUpdatePermission && (
            <span style={{ cursor: "pointer" }}>
              <Tooltip
                title="Edit Group Name"
                classes={{ popper: "custom-tooltip" }}
              >
                <EditIcon
                  style={{
                    borderRadius: "25%",
                    color: "#6A7B8E",
                    fontSize: "20px",
                  }}
                  onClick={this.handleEditGroupOpen.bind(this)}
                />
              </Tooltip>
            </span>
          )}
        </span>
      </>
    );
  }

  handleAddNewContactOpen() {
    this.setState({
      open: true,
      isOptin: false,
      checkCSVFile: false,
      action: "view",
      pageId: "addContact",
      mobileNo: "",
      mobile: "",
      firstName: "",
      lastName: "",
      email: "",
      countryCode:
        this.defaultCountry !== null
          ? `+${this.defaultCountry?.phoneCode}`
          : "",
    });
  }
  handleEditContactOpen(data) {
    let mobileNo = Utils.phoneNumberFormate(data.mobile);
    this.setState({
      open: true,
      action: "view",
      pageId: "editContact",
      mobileNo: mobileNo,
      mobile: data.mobile,
      countryCode: data.countryCode,
      firstName: data?.firstName,
      lastName: data?.lastName,
      email: data?.email,
      isOptin: data.isOptin,
      isActive: data.isActive,
      contactId: data.contactId,
    });
  }

  handleClose() {
    this.setState({ open: false });
  }

  formatToDashed(input) {
    const digits = input.toString().replace(/\D/g, "");
    if (digits.length !== 10) return digits;
    return digits.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
  }

  handleMobileNoChange(e) {
    let val = e.target.value;
    if (val.length <= 12) {
      let value = Utils.phoneNumberFormate(val);
      let mobile = e.target.value.replace(/-/g, "");
      if (mobile.length === 10) {
        this.searchExistingMobileNo(value);
      }
      this.setState({
        mobileNo: value,
        mobile: mobile,
      });
    }
  }

  handleCountryChange(phone, country, e, formattedValue) {
    this.setState({
      countryCode: formattedValue,
    });
  }
  searchExistingMobileNo(mobileNo) {
    const postObject = {
      header: this.header,
      smsContact: {
        mobile: mobileNo,
        countryCode: this.state.countryCode,
      },
      eventId: this.businessDomainId,
    };
    if (
      !Utils.isNullOrEmpty(this.state.mobileNo) &&
      this.state.mobileNo.length >= 10
    ) {
      FetchServerData.callPostService(FindByNumber_Url, postObject).then(
        (output) => {
          if (output.status === "SUCCESS") {
            let smsContact = output.data.smsContact;
            this.setState({
              firstName: smsContact?.firstName,
              lastName: smsContact?.lastName,
              email: smsContact?.email,
              // isOptin: smsContact?.isOptin,
            });
          } else {
          }
        }
      );
    }
  }

  handleFirstNameChange(e) {
    this.setState({ firstName: e.target.value });
  }
  handleLastNameChange(e) {
    this.setState({ lastName: e.target.value });
  }
  handleEmailChange(e) {
    this.setState({ email: e.target.value });
  }

  handleOptinChange(e) {
    this.setState({ isOptin: e.target.checked, error: false });
  }

  createGroupContactToBackend() {
    if (!this.state.isOptin) {
      this.setState({
        error: true,
      });
      return;
    }
    const postObject = {
      header: this.header,
      smsGroupContact: {
        smsGroup: {
          id: this.state.groupId,
        },
        smsContact: {
          mobile: this.state.mobile,
          countryCode: this.state.countryCode,
          firstName: this.state.firstName,
          lastName: this.state.lastName,
          email: this.state.email,
          isOptin: this.state.isOptin,
        },
        eventId: this.businessDomainId,
      },
    };
    FetchServerData.callPostService(CreateGroupContact_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          this.getGroupDetails(this.state.groupId, this.state.pageNo, this.state.pageSize, this.state.sortColumn, this.state.isAscSort);
          this.setState({
            open: false,
          });
        }
      }
    );
  }
  addAnotherContactToBackend = () => {
    if (!this.state.isOptin) {
      this.setState({
        error: true,
      });
      return;
    }
    const postObject = {
      header: this.header,
      smsGroupContact: {
        smsGroup: {
          id: this.state.groupId,
        },
        smsContact: {
          mobile: this.state.mobile,
          countryCode: this.state.countryCode,
          firstName: this.state.firstName,
          lastName: this.state.lastName,
          email: this.state.email,
          isOptin: this.state.isOptin,
        },
        eventId: this.businessDomainId,
      },
    };
    FetchServerData.callPostService(CreateGroupContact_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          this.getGroupDetails(this.state.groupId, this.state.pageNo, this.state.pageSize, this.state.sortColumn, this.state.isAscSort);
          this.setState({
            open: true,
            isOptin: false,
            checkCSVFile: false,
            action: "view",
            pageId: "addContact",
            mobileNo: "",
            mobile: "",
            firstName: "",
            lastName: "",
            email: "",
            countryCode:
              this.defaultCountry !== null
                ? `+${this.defaultCountry?.phoneCode}`
                : "",
          });
        }
      }
    );
  }

  updateContactToBackend() {
    // if (!this.state.isOptin) {
    //   this.setState({
    //     error: true,
    //   });
    //   return;
    // }

    const postObject = {
      header: this.header,
      smsContact: {
        mobile: this.state.mobile,
        countryCode: this.state.countryCode,
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        email: this.state.email,
        // isOptin: this.state.isOptin,
        id: this.state.contactId,
      },
      eventId: this.businessDomainId,
    };
    FetchServerData.callPostService(UpdateContact_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          this.getGroupDetails(this.state.groupId, this.state.pageNo, this.state.pageSize, this.state.sortColumn, this.state.isAscSort);
          this.setState({
            open: false,
          });
        } else {
        }
      }
    );
  }

  handleDownloadReportClose() {
    this.setState({
      isDownloadReport: false,
    });
  }
  handleDownloadReportOpen() {
    this.setState({
      isDownloadReport: true,
    });
  }
  handleDeleteContactsOpen() {
    this.setState({
      isContactConfirmBoxOpen: true,
    });
  }
  handleDeleteContactsClose() {
    this.setState({
      isContactConfirmBoxOpen: false,
    });
  }

  handleEditGroupOpen() {
    this.getUserList();
    this.setState({
      openGroup: true,
      // action: "edit",
      // groupName: data.name,
      // groupId: data.id,
    });
  }
  handleGroupClose() {
    this.setState({
      openGroup: false,
    });
  }

  getUserList() {
    const postObject = {
      header: this.header,
    };
    FetchServerData.callPostService(UserList_Url, postObject).then((output) => {
      if (output.status === "SUCCESS") {
        let userList = output.data.appuserList;
        this.setState({
          render: true,
          userList: userList,
        });
      } else {
      }
    });
  }

  handleGroupCreatedByChange(selectedValue) {
    this.setState({
      groupCreatedBy: selectedValue
    })
  }
  handleRowClick = (e, rowData, index) => {
    if (e.target.closest(".action-button")) return; // Skip if clicking action button

    const { isCtrlPressed, isShiftPressed } = this.state;

    // Determine list key and allSelected key based on status

    let selectedItems = [...this.state.smsContactList];

    if (isCtrlPressed || isShiftPressed) {
      // Multi-select range logic
      const firstItemIndex = selectedItems.findIndex((item) => item.checked);
      let lastItemIndex = index;

      if (firstItemIndex !== -1) {
        // Swap if needed
        const [start, end] =
          firstItemIndex < lastItemIndex
            ? [firstItemIndex, lastItemIndex]
            : [lastItemIndex, firstItemIndex];

        for (let i = start; i <= end; i++) {
          selectedItems[i].checked = true;
        }
      } else {
        // If no first checked item, just toggle current row
        selectedItems[index].checked = !selectedItems[index].checked;
      }
    } else {
      // Toggle single row selection
      selectedItems[index].checked = !selectedItems[index].checked;
    }

    // Calculate overall selection states
    const allChecked = selectedItems.every((item) => item.checked);
    const anyChecked = selectedItems.some((item) => item.checked);

    this.setState({
      smsContactList: selectedItems,
      allCheckBoxSelected: allChecked,
      isSelected: anyChecked,
    });
  };

  // handleSort(column) {
  //   const { sortColumn, sortDirection, smsContactList } = this.state;
  //   let newDirection = "asc";

  //   if (sortColumn === column && sortDirection === "asc") {
  //     newDirection = "desc";
  //   }

  //   this.setState({
  //     smsContactList: Utils.sortList(smsContactList, column, newDirection),
  //     sortColumn: column,
  //     sortDirection: newDirection,
  //   });
  // }

  handleSort(column) {
    const { sortColumn, sortDirection, pageNo, pageSize } = this.state;
    const newDirection =
      sortColumn === column && sortDirection === "asc" ? "desc" : "asc";

    const isAscSort = newDirection === "asc";
    const groupContactsState = {
      pageSize: pageSize,
      sortColumn: column,
      isAscSort: isAscSort,
    };
    store.dispatch(
      PaginationRowAction.setGroupContactsPaginationState({ groupContactsState })
    );
    this.setState(
      {
        sortColumn: column,
        sortDirection: newDirection,
        isAscSort: isAscSort,
      },
      () => {
        this.getGroupDetails(this.state.groupId, pageNo, pageSize, column, isAscSort);
      }
    );
  }

  requestActivateImportContact() {
    const postObject = {
      header: this.header,
    };

    FetchServerData.callPostService(
      "/supportms/requestActivateImportContact",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        PtsAlert.success(output.message);
        this.setState({
          isImportDisableOpen: false,
        });
      } else {
      }
    });
  }

  cancelImportExcelFile() {
    this.setState({
      selectedFile: { name: "" }
    })
  }

  handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      this.setState({ selectedFile: file });
      this.onFileChange(file);
    }
  };
  handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) {
      this.setState({ selectedFile: file, isDragging: false });
      this.onFileChange(file);
    }
  };

  handleDragOver = (e) => {
    e.preventDefault();
    this.setState({ isDragging: true });
  };

  handleDragLeave = (e) => {
    e.preventDefault();
    this.setState({ isDragging: false });
  };
  render() {
    if (this.state.action === "create") {
      return this.createGroup();
    } else if (this.state.action === "edit") {
      return this.editGroup();
    } else if (this.state.action === "view") {
      return this.viewGroup();
    }
  }

  createGroup() {
    return (
      <>
        <MenuWithBreadScrum
          breadCrumb={this.state.breadCrumb}
          navigate={this.props.navigate}
          domainObject="Group"
          name="Add Group"
        />
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-body" style={{ height: "100%" }}>
                <ValidatorForm
                  className="text-start"
                  ref="form"
                  onSubmit={this.createGroupToBackend.bind(this)}
                >
                  <div className="row d-flex justify-content-center">
                    <div className="col-md-4 mt-4">
                      <div className="row">
                        <label
                          className="col-sm-4 col-form-label fw-bold align-self-center"
                          htmlFor="basic-default-name"
                          id="assetFormLabel"
                        >
                          Group Name*
                        </label>
                        <div className="col-sm-8" id="givbeeText">
                          <input
                            title=""
                            required
                            autoFocus={true}
                            type="text"
                            autoComplete="off"
                            id="multiStepsFirstName"
                            name="multiStepsFirstName"
                            className="form-control"
                            value={this.state.groupName}
                            onChange={this.handleGroupNameChange.bind(this)}
                            validators={["required"]}
                            errormessages={["This field is required"]}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-4 mt-4 text-start align-self-center">
                      <CreateButton btnName="Create" type="submit" />
                      &nbsp;&nbsp;
                      <CancelIconButton
                        btnName="Cancel"
                        onClick={(e) => this.createCancel()}
                      />
                    </div>
                  </div>
                </ValidatorForm>
              </div>
            </div>
          </div >
        </div >
      </>
    );
  }

  viewGroup() {
    const validCountryCodes = this.countryListArray
      ?.filter((country) => ["US", "CA", "AU", "IN"].includes(country.code))
      .map((country) => country.code.toLowerCase());

    let checkedContactCount = this.state.smsContactList?.filter(
      (item) => item?.checked === true
    )?.length;

    const enableCountryCode = process.env.REACT_APP_ENABLE_COUNTRYCODE === "true";

    if (this.state.render === false) {
      return <div />;
    } else {
      return (
        <>
          <MenuWithBreadScrum
            breadCrumb={this.state.breadCrumb}
            navigate={this.props.navigate}
            domainObject={this.state.groupName}
            name={this.groupTitle()}
            title="Group"
            pageId="Group"
            // editCallback={this.editGroupDetails.bind(this)}
            // deleteCallback={this.deleteGroupToBackend.bind(this)}
            backCallback={this.viewCancel.bind(this)}
          // getDeletePermission={this.state.getDeletePermission}
          // getUpdatePermission={this.state.getUpdatePermission}
          />
          <div className="row">
            <div className="col">
              <div className="col md-12 mt-2">
                <div className="card rounded-0">
                  <div
                    className="row justify-content-between"
                    style={{ padding: "0.6em 1.2rem" }}
                  >
                    <div className="d-flex col-12 col-lg-8 col-xl-8 pe-0">
                      <div className="col-12 d-flex">
                        {/* <span>
                          <BackButton
                            type="button"
                            id="ptsHollowButton"
                            variant="contained"
                            onClick={(e) => this.viewCancel()}
                          >
                            Back
                          </BackButton>
                        </span> */}
                        {!Utils.equalsIgnoreCase(this.profile?.name, "Sender") &&
                          <span>
                            <PtsButton
                              btnName="Add Contact"
                              type="buttin"
                              onClick={this.handleAddNewContactOpen.bind(this)}
                            />
                          </span>
                        }
                        <span style={{ marginLeft: "0.7rem" }}>
                          {this.actionButton()}
                        </span>
                      </div>
                    </div>
                    <div className="d-flex col-12 col-lg-4 col-xl-4 text-end align-self-center">
                      {/* <div className="col-sm-3 text-end align-self-center">
                        <span className="totalResults">
                           Contacts: {this.state.totalRecords}
                        </span>
                      </div> */}
                      <div className="col-sm-12 text-end align-self-center">
                        <span className="totalResults me-4">
                          Contacts: {Utils.formatWithCommas(this.state.totalRecords)}
                        </span>
                        <span className="me-1">
                          <TextField
                            id="standard-search"
                            placeholder="Search"
                            type="text"
                            variant="standard"
                            style={{ width: "193px" }}
                            value={this.state.searchText}
                            onChange={this.onSearchChange.bind(this)}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <IconButton
                                    onClick={this.getGroupDetails.bind(
                                      this,
                                      this.state.groupId,
                                      this.state.pageNo,
                                      this.state.pageSize
                                    )}
                                  >
                                    <SearchIcon />
                                  </IconButton>
                                </InputAdornment>
                              ),
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton
                                    onClick={() => {
                                      this.setState({ searchText: "" }, () => {
                                        this.getGroupDetails(
                                          this.state.groupId,
                                          this.state.pageNo,
                                          this.state.pageSize
                                        );
                                      });
                                    }}
                                    disabled={!this.state.searchText}
                                  >
                                    <ClearIcon
                                      style={{
                                        opacity: this.state.searchText
                                          ? 1
                                          : 0.4,
                                        fontSize: "1.25rem",
                                        color: "353538",
                                      }}
                                    />
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="table-responsive paginationTable">
                    <table className="table text-start table-hover">
                      <thead className="paginationTableThead">
                        <tr>
                          <th scope="col fw-bold">
                            <input
                              type="checkbox"
                              style={{
                                width: "15px",
                                height: "15px",
                                marginTop: "6px",
                              }}
                              checked={this.state.allCheckBoxSelected}
                              onChange={this.onAllCheckBoxSelect.bind(this)}
                            />
                          </th>
                          <th scope="col fw-bold" style={{ cursor: "pointer" }}
                            onClick={() => this.handleSort("mobile")}>Mobile Number
                            {this.state.sortColumn === "mobile" &&
                              (this.state.sortDirection === "asc" ? (
                                <i
                                  class="fa fa-long-arrow-up ps-1"
                                  aria-hidden="true"
                                ></i>
                              ) : (
                                <i class="fa-solid fa-arrow-down-long ps-1"></i>
                              ))}</th>
                          <th
                            scope="col fw-bold"
                            style={{ cursor: "pointer" }}
                            onClick={() => this.handleSort("firstName")}
                          >
                            First Name
                            {this.state.sortColumn === "firstName" &&
                              (this.state.sortDirection === "asc" ? (
                                <i
                                  class="fa fa-long-arrow-up ps-1"
                                  aria-hidden="true"
                                ></i>
                              ) : (
                                <i class="fa-solid fa-arrow-down-long ps-1"></i>
                              ))}
                          </th>
                          <th
                            scope="col fw-bold"
                            style={{ cursor: "pointer" }}
                            onClick={() => this.handleSort("lastName")}
                          >
                            Last Name
                            {this.state.sortColumn === "lastName" &&
                              (this.state.sortDirection === "asc" ? (
                                <i
                                  class="fa fa-long-arrow-up ps-1"
                                  aria-hidden="true"
                                ></i>
                              ) : (
                                <i class="fa-solid fa-arrow-down-long ps-1"></i>
                              ))}
                          </th>
                          <th className="cursor-pointer" scope="col fw-bold" onClick={() => this.handleSort("email")}>
                            Email
                            {this.state.sortColumn === "email" &&
                              (this.state.sortDirection === "asc" ? (
                                <i
                                  class="fa fa-long-arrow-up ps-1"
                                  aria-hidden="true"
                                ></i>
                              ) : (
                                <i class="fa-solid fa-arrow-down-long ps-1"></i>
                              ))}
                          </th>
                          <th className="cursor-pointer" scope="col fw-bold" onClick={() => this.handleSort("lastMessageSenton")}>
                            Most Recent Activity
                            {this.state.sortColumn === "lastMessageSenton" &&
                              (this.state.sortDirection === "asc" ? (
                                <i
                                  class="fa fa-long-arrow-up ps-1"
                                  aria-hidden="true"
                                ></i>
                              ) : (
                                <i class="fa-solid fa-arrow-down-long ps-1"></i>
                              ))}
                          </th>
                          <th
                            scope="col fw-bold"
                            style={{ textAlign: "center" }}
                          >
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.smsContactList?.map((rowData, index) => (
                          <tr
                            key={index}
                            style={{
                              backgroundColor:
                                rowData.id === this.state.contactId
                                  ? "#FEF5E7"
                                  : "",
                            }}
                          >
                            <td style={{ width: "50px" }}>
                              <input
                                type="checkbox"
                                style={{
                                  width: "15px",
                                  height: "15px",
                                  marginTop: "6px",
                                }}
                                checked={
                                  rowData.checked ||
                                  this.state.allCheckBoxSelected
                                }
                                onChange={(e) =>
                                  this.onCheckBoxSelect(e, rowData, index)
                                }
                              />
                            </td>
                            <td
                              style={{ width: "175px" }}
                              onClick={(e) =>
                                this.handleRowClick(e, rowData, index)
                              }
                            >
                              <span
                                style={{
                                  color:
                                    rowData.contactStatus === "InvalidNumber"
                                      ? "#e60000"
                                      : "inherit",
                                }}
                              >
                                {rowData.mobile}
                              </span>
                            </td>
                            <td
                              style={{ width: "140px" }}
                              onClick={(e) =>
                                this.handleRowClick(e, rowData, index)
                              }
                            >
                              {rowData.firstName}
                            </td>
                            <td
                              style={{ width: "140px" }}
                              onClick={(e) =>
                                this.handleRowClick(e, rowData, index)
                              }
                            >
                              {rowData.lastName}
                            </td>
                            <td
                              style={{ width: "200px" }}
                              onClick={(e) =>
                                this.handleRowClick(e, rowData, index)
                              }
                            >
                              {rowData.email}
                            </td>
                            <td
                              style={{ width: "200px" }}
                              onClick={(e) =>
                                this.handleRowClick(e, rowData, index)
                              }
                            >
                              {rowData.lastMessageSenton}
                            </td>
                            <td
                              key={rowData.id}
                              style={{ width: "120px", textAlign: "center" }}
                            >
                              {this.showActionButton(rowData)}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  {this.state.totalRecords === 0 && (
                    <div
                      className="row text-center"
                      style={{ padding: "6px 20px" }}
                    >
                      <h5 className="dataNotAvailable">
                        There are no contacts in this group.
                      </h5>
                    </div>
                  )}
                  {this.state.totalRecords > 10 && (
                    <div className="row justify-content-between pagination p-1">
                      <div className="d-flex col-12 col-lg-4 col-xl-4">
                        <div className="pageSize col-12 text-start">
                          Page {this.state.pageNo + 1} of{" "}
                          {this.state.totalPages}
                        </div>
                      </div>
                      <div className="d-flex col-12 col-lg-8 col-xl-8">
                        <div className="col-12 text-end">
                          <Pagination
                            showPerPage={this.state.showPerPage}
                            onPaginationChange={this.onPaginationChange.bind(
                              this
                            )}
                            total={this.state.totalRecords}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="mt-3" style={{ width: "100%", textAlign: "start" }}>
            <BackButton
              type="button"
              style={{
                backgroundColor: "#162c50",
                color: "#fff",
                padding: "2px 10px",
              }}
              variant="contained"
              onClick={(e) => this.viewCancel()}
            >
              Back
            </BackButton>
          </div>

          <Dialog
            open={this.state.openViewGroup}
            onClose={this.handleViewGroupClose.bind(this)}
            maxWidth="xl"
            className="groupBelongingToDialogue"
          >
            <DialogTitle id="scroll-dialog-title">
              <span style={{ color: "#fff" }}>Groups Belonging To</span>
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={this.handleViewGroupClose.bind(this)}
              style={{
                position: "absolute",
                right: 8,
                top: 4,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
            </IconButton>
            <DialogContent>
              <div
                md={12}
                style={{
                  width: "100%",
                  color: "#000",
                  fontSize: "small",
                  padding: "0.5em",
                }}
              >
                <div className="row">
                  <div className="col-md-12" style={{ paddingLeft: "20px" }}>
                    <div className="row">
                      <label
                        className="col-sm-1 col-form-label fw-bold"
                        htmlFor="basic-default-supplierType"
                        id="assetFormLabel"
                      >
                        Name
                      </label>
                      <div className="col-sm-11" id="givbeeText">
                        <span>{`${this.state.firstName !== null
                          ? this.state.firstName
                          : ""
                          } ${this.state.lastName !== null
                            ? this.state.lastName
                            : ""
                          }`}</span>
                      </div>
                    </div>
                    <div className="row">
                      <label
                        className="col-sm-1 col-form-label fw-bold"
                        htmlFor="basic-default-supplierType"
                        id="assetFormLabel"
                      >
                        Mobile
                      </label>
                      <div className="col-sm-11" id="givbeeText">
                        <span>
                          {Utils.phoneNumberFormate(this.state.mobileNo)}
                        </span>
                      </div>
                    </div>
                    <div className="row">
                      <label
                        className="col-sm-1 col-form-label fw-bold"
                        htmlFor="basic-default-supplierType"
                        id="assetFormLabel"
                      >
                        Email
                      </label>
                      <div className="col-sm-11" id="givbeeText">
                        <span>{this.state.email}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row p-2 pt-4 groupForContact materialTable">
                  <MaterialTable
                    title=""
                    box-shadow
                    // onRowClick={(event, rowData) => {
                    //   this.editContactDetails(event, rowData);
                    //   event.stopPropagation();
                    // }}
                    icons={UiUtils.getMaterialTableIcons()}
                    localization={{
                      body: {
                        emptyDataSourceMessage: (
                          <h5 className="dataNotAvailable">No data found.</h5>
                        ),
                      },
                    }}
                    columns={[
                      {
                        title: "#",
                        render: (rowData) => rowData.tableData.id + 1,
                        width: "5%",
                        align: "left",
                        cellStyle: {
                          width: "6%",
                        },
                      },
                      {
                        title: "Group Name",
                        field: "name",
                      },
                      {
                        title: "Date added",
                        field: "createdOn",
                      },
                      {
                        title: "Action",
                        sorting: false,
                        disableClick: true,
                        render: (rowData) => {
                          return (
                            <span
                              className="me-2"
                              style={{ cursor: "pointer" }}
                            >
                              <RemoveContactButton
                                domainObject={Utils.phoneNumberFormate(
                                  this.state.mobileNo
                                )}
                                onClick={this.deleteContactToGroup.bind(
                                  this,
                                  rowData
                                )}
                                pageId="contactGroup"
                              />
                            </span>
                          );
                        },
                      },
                    ]}
                    data={this.state.smsGroupList}
                    options={{
                      sorting: true,
                      search: false,
                      emptyRowsWhenPaging: false,
                      actionsColumnIndex: -1,
                      paging: false,
                    }}
                  />
                </div>
              </div>
            </DialogContent>
          </Dialog>

          <Dialog
            open={this.state.isImportOpen}
            onClose={this.handleImportDropdownClose}
            maxWidth="xl"
            className="importContactDialogue"
          >
            <DialogTitle id="scroll-dialog-title">
              <span style={{ color: "#fff" }}>Import Contacts</span>
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={this.handleImportDropdownClose.bind(this)}
              style={{
                position: "absolute",
                right: 8,
                top: 4,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
            </IconButton>
            <DialogContent>
              <div className="row pt-3">
                {this.accountSettings?.enableImport ? (
                  <div className="col-sm-12">
                    <div className="groupCustom-steps">
                      <div className="groupCustom-step">
                        <div className="row d-flex">
                          <div className="col-sm-12">
                            <label>
                              <a
                                href={SmsContactImportFile}
                                style={{
                                  color: "#1957b4",
                                  cursor: "pointer",
                                  fontSize: "14px",
                                }}
                                id="dwnlink"
                                download="GivBee_Optin_List_Upload_Template.CSV"
                              >
                                <u>Download our CSV template</u>
                              </a> Use this CSV template for uploading. <span style={{ fontSize: "13px" }}>(required)</span>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="groupCustom-step">
                        <div className="row mt-4">
                          {this.state.selectedFile?.name === "" ?
                            <div
                              className="col-sm-7 csvFile"
                              style={{ display: "inline-block", cursor: "pointer" }}
                            >
                              <div className="file-upload-wrapper">
                                <label
                                  htmlFor="import-csvfile"
                                  className={`customImageVideo-file-upload ${this.state.isDragging ? "dragging" : ""
                                    }`}
                                  onDrop={this.handleDrop}
                                  onDragOver={this.handleDragOver}
                                  onDragLeave={this.handleDragLeave}
                                >
                                  <CloudUploadIcon className="upload-icon" />
                                  <span className="upload-text">
                                    Drop or{" "}
                                    <span className="browse-link">browse CSV files here</span>
                                  </span>

                                  <input
                                    required
                                    id="import-csvfile"
                                    type="file"
                                    accept=".csv"
                                    ref={this.fileUploadRef}
                                    onChange={this.handleFileChange}
                                  />
                                </label>

                                {/* <small className="upload-note">
                                  {this.state.selectedFile?.name === ""
                                    ? "Choose CSV file"
                                    : this.state.selectedFile?.name}
                                </small> */}
                              </div>
                            </div>
                            :
                            <div
                              className="col-sm-12 csvFile"
                              style={{ display: "inline-block", cursor: "pointer" }}
                            >
                              <div className="align-content-center" style={{ height: "76.61px" }}>
                                <p
                                  className="mb-0 anchortag"
                                  id="fileLabel"
                                  style={{ display: "inline" }}
                                >
                                  {this.state.selectedFile?.name === ""
                                    ? ""
                                    : Utils.truncateString(this.state.selectedFile?.name, 60)}
                                </p>
                                <span className="fw-bold ms-2">
                                  <ClearIcon
                                    className="logoDelete"
                                    style={{
                                      cursor: "pointer",
                                      borderRadius: "50%",
                                      border: "solid 2px",
                                      color: "#697a8d",
                                    }}
                                    onClick={this.cancelImportExcelFile.bind(
                                      this
                                    )}
                                  />
                                </span>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                      <div className="groupCustom-step">
                        <div className="row" style={{ marginTop: "1.5em" }}>
                          <div className="col-md-12 d-flex">
                            <span className="me-3 importCheckboxSize pt-1">
                              {/* <FormControlLabel
                            style={{
                              display: "flex",
                              alignItems: "flex-start",
                              marginTop: -4,
                              paddingLeft: "10px",
                              marginRight: "0",
                            }}
                            control={
                              <Checkbox
                                variant="outlined"
                                id="isAsset"
                                checked={this.state.checkCSVFile}
                                value={this.state.checkCSVFile}
                                onChange={this.checkCSVFilekHandler.bind(this)}
                                style={{
                                  padding: 0,
                                  // marginTop: -2,
                                  background: "none",
                                }}
                              />
                            }
                            label={
                              <Typography
                                component="span"
                                sx={{ fontSize: "0.9375rem" }}
                              >
                                On behalf of{" "}
                                {this.companyName ? this.companyName : ""}, I
                                verify that the person with this mobile number
                                has given permission to be added to the opt-in
                                list for this account.
                              </Typography>
                            }
                          /> */}
                              <FormControlLabel
                                style={{
                                  alignItems: "flex-start",
                                  marginTop: -4,
                                  paddingLeft: "10px",
                                  marginRight: "0",
                                }}
                                control={
                                  <Checkbox
                                    id="isAsset"
                                    checked={this.state.checkCSVFile}
                                    onChange={this.checkCSVFilekHandler.bind(this)}
                                    style={{
                                      padding: 0,
                                      // marginTop: 2,
                                      marginRight: "8px",
                                      alignSelf: "flex-start",
                                    }}
                                  />
                                }
                                label={
                                  <Typography
                                    component="span"
                                    sx={{
                                      fontSize: "0.9375rem",
                                      lineHeight: "1.4rem",
                                    }}
                                  >
                                    On behalf of{" "}
                                    {this.companyName ? this.companyName : ""}, I
                                    verify that all persons on the selected list
                                    have given permission to be added to the opt-in
                                    list for this account.
                                  </Typography>
                                }
                                componentsProps={{
                                  typography: { sx: { marginTop: "0px" } },
                                }}
                              />
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="row ms-1 mt-3">
                        <div class="col-md-12 text-center ps-3">
                          <Button
                            id="ptsButton"
                            type="button"
                            // style={{
                            //   background:
                            //     this.state.checkCSVFile &&
                            //     this.state.selectedFile?.name !== ""
                            //       ? "#b6bec8"
                            //       : "#ccc",
                            // }}
                            onClick={
                              this.state.checkCSVFile &&
                                this.state.selectedFile?.name !== ""
                                ? this.excelImportContactToGroup.bind(this)
                                : undefined
                            }
                            disabled={
                              !(
                                this.state.checkCSVFile &&
                                this.state.selectedFile?.name !== ""
                              )
                            }
                          >
                            Import
                          </Button>
                        </div>
                      </div>
                      <div className="row mt-2" style={{ height: "25px" }}>
                        {this.state.isProgress && (
                          <LinearProgressWithLabel value={this.state.progress} />
                        )}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="col-sm-12">
                    <div className="row">
                      <span style={{ textAlign: "center" }}>
                        <p className="m-0" style={{ fontSize: "16px" }}>
                          Please contact customer support to activate this
                          feature.
                        </p>
                      </span>
                    </div>
                    <div className="row mt-3 align-items-center">
                      <div class="col-md-12 text-center">
                        <Button
                          id="ptsButton"
                          type="button"
                          style={{
                            background: "#b6bec8",
                          }}
                        >
                          Contact Customer support
                        </Button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </DialogContent>
          </Dialog >
          <Dialog
            open={this.state.openSkippedNumbers}
            onClose={this.handleSkippedNumbersClose}
            maxWidth="xl"
            className="importContactDialogue"
          >
            <DialogTitle id="scroll-dialog-title">
              <span style={{ color: "#fff" }}>Skipped Numbers</span>
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={this.handleSkippedNumbersClose.bind(this)}
              style={{
                position: "absolute",
                right: 8,
                top: 4,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
            </IconButton>
            <DialogContent>
              <div className="row p-2">
                <p className="ps-2">{this.state.skippedNumbers?.length} contacts can not be imported for the following reasons.</p>
                {this.state.skippedNumbers &&
                  this.state.skippedNumbers.length > 0 ? (
                  <table className="table table-bordered table-sm">
                    <thead>
                      <tr>
                        <th
                          style={{
                            width: "60px",
                            fontSize: "14px",
                          }}
                        >
                          #
                        </th>
                        <th
                          style={{
                            textTransform: "capitalize",
                            fontSize: "14px",
                          }}
                        >
                          Reason
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.skippedNumbers.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td style={{ color: "red" }}>{item}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <div className="text-center text-muted">
                    No skipped numbers found.
                  </div>
                )}
              </div>
            </DialogContent>
          </Dialog>
          <Dialog
            open={this.state.isImportDisableOpen}
            onClose={this.handleImportDisableClose.bind(this)}
            style={{ padding: "1em" }}
          >
            <DialogContent>
              <div className="row">
                <span style={{ textAlign: "center" }}>
                  <p className="m-0" style={{ fontSize: "16px" }}>
                    Please contact customer support to activate this feature.
                  </p>
                </span>
              </div>
            </DialogContent>
            <DialogActions
              style={{
                // marginTop: "1em",
                padding: "1em",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <Button
                variant="contained"
                type="button"
                size="large"
                style={{
                  background: "#37517e",
                  color: "#fff",
                  marginRight: "1rem",
                  padding: "2px 10px",
                  textTransform: "capitalize",
                }}
                // startIcon={<SaveIcon />}
                onClick={this.requestActivateImportContact.bind(this)}
              >
                Contact Customer Support
              </Button>
              <Button
                variant="contained"
                size="large"
                type="button"
                style={{
                  background: "#717373",
                  color: "#fff",
                  marginRight: "1rem",
                  padding: "2px 10px",
                  textTransform: "capitalize",
                }}
                startIcon={<CloseIcon />}
                onClick={this.handleImportDisableClose.bind(this)}
              >
                Cancel
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={this.state.open}
            onClose={this.handleClose.bind(this)}
            maxWidth="xl"
            className="importContactDialogue"
          >
            <DialogTitle id="scroll-dialog-title">
              <span style={{ color: "#fff" }}>
                {this.state.pageId === "addContact"
                  ? `Add Contact to Group: ${this.state.groupName}`
                  : `Edit Contact`}
              </span>
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={this.handleClose.bind(this)}
              style={{
                position: "absolute",
                right: 8,
                top: 4,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
            </IconButton>
            <ValidatorForm
              className="text-start"
              ref="form"
              onSubmit={
                this.state.pageId === "addContact"
                  ? this.createGroupContactToBackend.bind(this)
                  : this.updateContactToBackend.bind(this)
              }
            >
              <DialogContent className="pb-2">
                <div className="row ps-4 pe-4">
                  <div className="col-sm-12">
                    <div className="row">
                      <div className="col-md-6" id="assetFormLabel">
                        {this.state.pageId === "addContact" ? (
                          <>
                            <label
                              className="form-label "
                              htmlFor="collapsible-firstname"
                            >
                              Mobile Number*
                            </label>
                            {enableCountryCode ?
                              <span className="d-flex">
                                <PhoneInput
                                  country={this.defaultCountry?.code
                                    ?.toString()
                                    ?.toLowerCase()}
                                  onlyCountries={validCountryCodes}
                                  disabled={
                                    this.state.pageId === "addContact"
                                      ? false
                                      : true
                                  }
                                  value={this.state.countryCode}
                                  onChange={(
                                    phone,
                                    country,
                                    e,
                                    formattedValue
                                  ) => {
                                    this.handleCountryChange(
                                      phone,
                                      country,
                                      e,
                                      formattedValue
                                    );
                                  }}
                                  autoFormat
                                  countryCodeEditable={false}
                                  disableCountryGuess={false}
                                  enableSearch={true}
                                  alwaysDefaultMask={true}
                                />
                                <input
                                  title=""
                                  required
                                  autoFocus={true}
                                  type="text"
                                  autoComplete="off"
                                  id="multiStepsFirstName"
                                  name="multiStepsFirstName"
                                  className="form-control"
                                  value={this.state.mobileNo}
                                  onChange={this.handleMobileNoChange.bind(this)}
                                  onBlur={(e) => {
                                    const formatted = this.formatToDashed(
                                      e.target.value
                                    );
                                    this.setState({ mobileNo: formatted });
                                  }}
                                  onPaste={(e) => {
                                    e.preventDefault();
                                    const pasted =
                                      e.clipboardData.getData("Text");
                                    const formatted = this.formatToDashed(pasted);
                                    this.setState({
                                      mobileNo: formatted,
                                      mobile: pasted?.replace(/-/g, "")
                                    });
                                  }}
                                />
                              </span>
                              :
                              <input
                                title=""
                                required
                                autoFocus={true}
                                type="text"
                                autoComplete="off"
                                id="multiStepsFirstName"
                                name="multiStepsFirstName"
                                className="form-control"
                                value={this.state.mobileNo}
                                onChange={this.handleMobileNoChange.bind(this)}
                                onBlur={(e) => {
                                  const formatted = this.formatToDashed(
                                    e.target.value
                                  );
                                  this.setState({ mobileNo: formatted });
                                }}
                                onPaste={(e) => {
                                  e.preventDefault();
                                  const pasted =
                                    e.clipboardData.getData("Text");
                                  const formatted = this.formatToDashed(pasted);
                                  this.setState({
                                    mobileNo: formatted,
                                    mobile: pasted?.replace(/-/g, "")
                                  });
                                }}
                              />
                            }
                          </>
                        ) : (
                          <>
                            <label
                              className="form-label "
                              htmlFor="collapsible-firstname"
                            >
                              Mobile Number
                            </label>
                            <span
                              className="d-flex"
                              style={{ paddingLeft: "13px" }}
                            >
                              {this.state.mobileNo}
                            </span>
                          </>
                        )}
                      </div>
                    </div>
                    <div className="row mt-1">
                      <div className="col-md-6" id="assetFormLabel">
                        <label
                          className="form-label "
                          htmlFor="collapsible-firstname"
                        >
                          First Name
                        </label>
                        <input
                          type="text"
                          autoComplete="off"
                          id="multiStepsFirstName"
                          name="multiStepsFirstName"
                          className="form-control"
                          value={this.state.firstName}
                          onChange={this.handleFirstNameChange.bind(this)}
                          validators={["required"]}
                          errormessages={["This field is required"]}
                        />
                      </div>
                    </div>
                    <div className="row mt-1">
                      <div className="col-md-6" id="assetFormLabel">
                        <label
                          className="form-label "
                          htmlFor="collapsible-lastname"
                        >
                          Last Name
                        </label>
                        <input
                          type="text"
                          autoComplete="off"
                          id="multiStepsFirstName"
                          name="multiStepsFirstName"
                          className="form-control"
                          value={this.state.lastName}
                          onChange={this.handleLastNameChange.bind(this)}
                          validators={["required"]}
                          errormessages={["This field is required"]}
                        />
                      </div>
                    </div>
                    <div className="row mt-1">
                      <div className="col-md-6" id="assetFormLabel">
                        <label
                          className="form-label "
                          htmlFor="collapsible-lastname"
                        >
                          Email
                        </label>
                        <input
                          type="text"
                          autoComplete="off"
                          id="multiStepsFirstName"
                          name="multiStepsFirstName"
                          className="form-control"
                          value={this.state.email}
                          onChange={this.handleEmailChange.bind(this)}
                          validators={["required"]}
                          errormessages={["This field is required"]}
                        />
                      </div>
                    </div>
                    {this.state.pageId === "addContact" && (
                      <div className="row mt-2" style={{ minHeight: "70px" }}>
                        <div
                          className="col-12 d-flex align-items-start flex-wrap"
                          id="assetFormLabel"
                        >
                          <span className="me-3 importCheckboxSize">
                            <FormControlLabel
                              style={{
                                color: "#000",
                                width: "100%",
                                margin: "0",
                                padding: "0",
                                alignItems: "flex-start",
                              }}
                              control={
                                <Checkbox
                                  id="isChecked"
                                  checked={this.state.isOptin}
                                  onChange={this.handleOptinChange.bind(this)}
                                  style={{
                                    padding: "0",
                                    marginRight: "8px",
                                    transform: "scale(0.9)",
                                    alignSelf: "self-start",
                                  }}
                                  sx={{
                                    "& .MuiSvgIcon-root": {
                                      fontSize: 18,
                                    },
                                  }}
                                />
                              }
                              label={
                                <span
                                  className="form-label"
                                  style={{
                                    fontSize: "14px",
                                    lineHeight: "18px",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  {`On behalf of ${this.companyName ? this.companyName : ""
                                    }, I verify that the person with this mobile number has given permission to be added to the opt-in list for this account.`}
                                </span>
                              }
                            />
                          </span>
                          {this.state.error && (
                            <p
                              className="text-danger mb-0"
                              style={{
                                paddingLeft: "36px",
                                fontSize: "13px",
                                marginTop: "2px",
                              }}
                            >
                              Please verify opt-in
                            </p>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="row d-flex justify-content-center p-4">
                  <div className="col-sm-12 text-center align-self-center">
                    <CreateButton btnName="Create" type="submit" />
                    &nbsp;
                    <Button
                      id="ptsHollowButton"
                      variant="contained"
                      type="button"
                      style={{ marginRight: "0.6rem" }}
                      onClick={this.addAnotherContactToBackend}
                    >
                      Save & Add Another
                    </Button>
                    &nbsp;
                    <CancelIconButton
                      btnName="Cancel"
                      onClick={(e) => this.handleClose()}
                    />
                  </div>
                </div>
              </DialogContent>
            </ValidatorForm>
          </Dialog >

          <Dialog
            open={this.state.isDownloadReport}
            onClose={this.handleDownloadReportClose.bind(this)}
            style={{ padding: "1em" }}
          >
            <DialogContent>
              <span style={{ textAlign: "center" }}>
                <p className="mb-2" style={{ fontSize: "16px" }}>
                  This feature is not enabled for your user type. Please contact
                  admin.
                </p>
              </span>
            </DialogContent>
          </Dialog>

          <Dialog
            open={this.state.isContactConfirmBoxOpen}
            onClose={this.handleDeleteContactsClose.bind(this)}
            style={{ padding: "1em" }}
          >
            <DialogContent>
              <span style={{ textAlign: "center" }}>
                <p className="m-0" style={{ fontSize: "16px" }}>
                  These {checkedContactCount} contacts will be removed from this Group.
                </p>
              </span>
            </DialogContent>
            <DialogActions
              style={{
                padding: "1em",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <Button
                variant="contained"
                type="button"
                size="large"
                style={{
                  background: "#37517e",
                  color: "#fff",
                  marginRight: "1rem",
                  padding: "2px 10px",
                  textTransform: "capitalize",
                }}
                startIcon={<SaveIcon />}
                onClick={this.deleteMultipleContact.bind(this)}
              >
                Confirm
              </Button>
              <Button
                variant="contained"
                size="large"
                type="button"
                style={{
                  background: "#717373",
                  color: "#fff",
                  marginRight: "1rem",
                  padding: "2px 10px",
                  textTransform: "capitalize",
                }}
                startIcon={<CloseIcon />}
                onClick={this.handleDeleteContactsClose.bind(this)}
              >
                Cancel
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={this.state.openGroup}
            onClose={this.handleGroupClose.bind(this)}
            maxWidth="xl"
            className="importContactDialogue"
          >
            <DialogTitle id="scroll-dialog-title">
              <span style={{ color: "#fff" }}>Edit Group</span>
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={this.handleGroupClose.bind(this)}
              style={{
                position: "absolute",
                right: 8,
                top: 4,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
            </IconButton>
            <ValidatorForm
              className="text-start"
              ref="form"
              onSubmit={this.updateGroupToBackend.bind(this)}
            >
              <DialogContent className="pb-4">
                <div className="row d-flex justify-content-center">
                  <div className="col-md-9">
                    <div className="row">
                      <label
                        className="col-sm-4 col-form-label fw-bold align-self-center"
                        htmlFor="basic-default-name"
                        id="assetFormLabel"
                      >
                        Group Name
                      </label>
                      <div className="col-sm-8" id="givbeeText">
                        <input
                          title=""
                          required
                          autoFocus={true}
                          type="text"
                          autoComplete="off"
                          id="multiStepsFirstName"
                          name="multiStepsFirstName"
                          className="form-control"
                          value={this.state.editGroupName}
                          onChange={this.handleEditGroupNameChange.bind(this)}
                          validators={["required"]}
                          errormessages={["This field is required"]}
                        />
                      </div>
                    </div>
                    <div className="row mt-3">
                      <label
                        className="col-sm-4 col-form-label fw-bold align-self-center"
                        htmlFor="basic-default-name"
                        id="assetFormLabel"
                      >
                        Created By
                      </label>
                      <div className="col-sm-8" id="givbeeText">
                        <Autocomplete
                          id="size-small-outlined"
                          size="small"
                          fullWidth
                          disableClearable
                          autoComplete="off"
                          ListboxProps={{
                            className: "custom-listbox",
                          }}
                          options={this.state.userList}
                          value={this.state.groupCreatedBy}
                          getOptionLabel={(option) => option.name}
                          defaultValue={this.state.groupCreatedBy}
                          onChange={(event, value) => {
                            this.handleGroupCreatedByChange(value);
                          }}
                          inputprops={{
                            style: { textTransform: "capitalize" },
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              title=""
                              placeholder="Please Select"
                              variant="outlined"
                              size="small"
                              className="autoComplete"
                              style={{ background: "#fff" }}
                            />
                          )}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </DialogContent>
              <DialogActions className="justify-content-center p-4">
                <div className="row d-flex justify-content-center">
                  <div className="col-sm-12 text-start align-self-center">
                    <CreateButton btnName="Create" type="submit" />
                    &nbsp;&nbsp;
                    <CancelIconButton
                      btnName="Cancel"
                      onClick={(e) => this.handleGroupClose()}
                    />
                  </div>
                </div>
              </DialogActions>
            </ValidatorForm>
          </Dialog>
        </>
      );
    }
  }

  editGroup() {
    return (
      <>
        <MenuWithBreadScrum
          breadCrumb={this.state.breadCrumb}
          navigate={this.props.navigate}
          domainObject="Group"
          name="Edit Group"
        />
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-body" style={{ height: "100%" }}>
                <ValidatorForm
                  className="text-start"
                  ref="form"
                  onSubmit={this.updateGroupToBackend.bind(this)}
                >
                  <div className="row d-flex justify-content-center">
                    <div className="col-md-4 mt-4">
                      <div className="row">
                        <label
                          className="col-sm-4 col-form-label fw-bold align-self-center"
                          htmlFor="basic-default-name"
                          id="assetFormLabel"
                        >
                          Group Name*
                        </label>
                        <div className="col-sm-8" id="givbeeText">
                          <input
                            title=""
                            required
                            type="text"
                            autoComplete="off"
                            id="multiStepsFirstName"
                            name="multiStepsFirstName"
                            className="form-control"
                            value={this.state.groupName}
                            onChange={this.handleGroupNameChange.bind(this)}
                            validators={["required"]}
                            errormessages={["This field is required"]}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-4 mt-4 text-start align-self-center">
                      <SaveButton btnName="Create" type="submit" />
                      &nbsp;&nbsp;
                      <CancelIconButton
                        btnName="Cancel"
                        onClick={(e) => this.editCancel()}
                      />
                    </div>
                  </div>
                </ValidatorForm>
              </div>
            </div>
          </div >
        </div >
      </>
    );
  }
}

export default withRouter(Group);
